// extracted by mini-css-extract-plugin
export var centerText = "_d9-8";
export var container = "_d9-0";
export var doughnutContainer = "_d9-7";
export var legend = "_d9-a";
export var legendItemColorDisplay = "_d9-b";
export var legendItemLabel = "_d9-d";
export var legendItemValue = "_d9-c";
export var lg = "_d9-5";
export var maxWidth = "_d9-9";
export var md = "_d9-4";
export var responsive = "_d9-6";
export var sm = "_d9-3";
export var xs = "_d9-2";
export var xxs = "_d9-1";